import * as ng from 'angular';
import { AccountRequest, IAccountRequestResource } from './data/account-request';
import { HomeContentCardComponent, IHomeContentCardController } from './user-controls/home-content-card';
import { AccountRequestComponent, IAccountRequestController } from './account-request';
import { accountRequestCompletedComponent, IaccountRequestCompletedController } from './account-request-complete';
import { FaqComponent, IFaqController } from './faq';
import { HomeComponent, IHomeController } from './home';
import { TermsComponent, ITermsController } from './terms';

let publicModule = ng.module("app.public", [
    'ngComponentRouter',
    //'ngRouteShim',
    'ngMaterial',
    'ngMessages',
    'mgo-angular-wizard',
    'gettext', // 3rd Party modules
    'angularMoment'

])
    .service(AccountRequest.name, AccountRequest.factory)
    .component(HomeContentCardComponent.name, HomeContentCardComponent.registration)
    .component(AccountRequestComponent.name, AccountRequestComponent.registration)
    .component(accountRequestCompletedComponent.name, accountRequestCompletedComponent.registration)
    .component(FaqComponent.name, FaqComponent.registration)
    .component(HomeComponent.name, HomeComponent.registration)
    .component(TermsComponent.name, TermsComponent.registration)

export {
    IAccountRequestResource,
    IHomeContentCardController,
    IAccountRequestController, IaccountRequestCompletedController, IFaqController, IHomeController, ITermsController
};
export default publicModule;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/public/index.ts